export const sections = [
    ['sales', 'فروش و سفارش‌ها', 'simple-icon-chart'],
    ['customers', 'خریداران و خرید مجدد', 'simple-icon-people'],
    ['products', 'محصولات', 'simple-icon-basket'],
    ['audience', 'مشخصات خریداران', 'simple-icon-pie-chart'],
];
export const peopleSections = [['growth','رشد مخاطبان','simple-icon-people'],['tags','سرنخ‌ها و تگ‌ها','simple-icon-tag'],['profiles','مشخصات مخاطبان','simple-icon-user'],['birthday','کوپن تولد','simple-icon-present']];
export const cohorts = { all: 'همه خریداران', new: 'مشتریان جدید', returning: 'مشتریان بازگشتی', unknown: 'ارتباط مشتری نامشخص' };
const persianParts = new Intl.DateTimeFormat('en-US-u-ca-persian', { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'Asia/Tehran' });
export const monthNames = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
export function periodHierarchy(periods, key) {
    const rows = periods.map(row => {
        const parts = Object.fromEntries(persianParts.formatToParts(new Date(row.date_start + 'T12:00:00+03:30')).map(p => [p.type, p.value]));
        return { ...row, year: Number(parts.year), month: Number(parts.month), day: Number(parts.day) };
    }).sort((a, b) => b.date_start.localeCompare(a.date_start));
    const selected = rows.find(r => r.period_key === key) || rows[0];
    return {
        rows, selected,
        years: [...new Set(rows.map(r => r.year))].sort((a, b) => b - a),
        months: [...new Set(rows.filter(r => r.year === selected?.year).map(r => r.month))].sort((a, b) => b - a),
        periods: rows.filter(r => r.year === selected?.year && r.month === selected?.month),
    };
}
export function selection(search) {
    const q = new URLSearchParams(search);
    return {
        type: ['day', 'week', 'month'].includes(q.get('type')) ? q.get('type') : 'month',
        key: /^\d{4}-\d{2}-\d{2}$/.test(q.get('period') || '') ? q.get('period') : null,
        section: [...sections,...peopleSections].some(([id]) => id === q.get('section')) ? q.get('section') : 'sales',
        cohort: Object.prototype.hasOwnProperty.call(cohorts, q.get('cohort')) ? q.get('cohort') : 'all',
        mode: q.get('mode') === 'products' ? 'products' : 'lines',
        kind: ['all', 'custom', 'nonstock'].includes(q.get('kind')) ? q.get('kind') : 'custom',
        page: /^[1-9]\d{0,6}$/.test(q.get('page') || '') ? Number(q.get('page')) : 1,
        size: [20, 50, 100].includes(Number(q.get('size'))) ? Number(q.get('size')) : 20,
    };
}
export function reportUrl({ type, key, section = 'sales', family = 'orders', ...detail }, items = false) {
    const q = new URLSearchParams({ type, ...(key ? { period: key } : {}), ...(items ? detail : { section }) });
    return `/app/reports/${items?'overview/items':family==='people'?'people':family==='operators'?'operators':'overview'}?${q.toString()}`;
}
